(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/best-rows/assets/javascripts/views/best-rows-list-item.js') >= 0) return;  svs.modules.push('/components/sport/best-rows/assets/javascripts/views/best-rows-list-item.js'); 'use strict';

svs.sport.best_rows.views.BestRowsListItem = Marionette.View.extend({
  template: function template(data) {
    return svs.sport.best_rows.templates.best_rows_list_item(data);
  },
  className: 'best-row-list-item'
});
 })(window);